/** Thai strings for the fortune teller prizes, hero names and slots, and the themed sets (English source text -> Thai). */
export const GACHA: Record<string, string> = {
  // Fortune teller page
  'Guaranteed: at least Rare every {rare} draws, Epic every {epic} draws and Legendary every {legendary} draws in a row without one.':
    'การันตี: ถ้าเปิดติดกัน {rare} ครั้งยังไม่ได้ระดับหายาก ครั้งนั้นได้หายากแน่นอน · {epic} ครั้งได้ระดับมหากาพย์ · {legendary} ครั้งได้ระดับตำนาน',
  'No duplicates: you only win things you do not have yet. When a whole tier is collected you get coins instead ({common} / {rare} / {epic} / {legendary}).':
    'ไม่มีของซ้ำ: ได้แต่ของที่ยังไม่มี ถ้าสะสมครบทั้งระดับแล้วจะได้เหรียญแทน ({common} / {rare} / {epic} / {legendary})',
  'Draws use free tickets or coins earned in play. They are never sold for real money.': 'การเปิดใช้ตั๋วฟรีหรือเหรียญที่ได้จากการเล่นเท่านั้น ไม่มีขายด้วยเงินจริง',
  "Free tickets: one every day, and one more for finishing all of today's quests (keep up to {max}). No ticket? A draw costs {cost} coins, or 5 draws {five} coins (up to {limit} coin draws a day).":
    'ตั๋วฟรี: วันละ 1 ใบ และอีก 1 ใบเมื่อทำภารกิจวันนี้ครบ (เก็บได้สูงสุด {max} ใบ) ไม่มีตั๋ว? เปิดครั้งละ {cost} เหรียญ หรือ 5 ครั้ง {five} เหรียญ (ใช้เหรียญเปิดได้วันละ {limit} ครั้ง)',
  'Collection: {owned} / {total}': 'สะสมแล้ว: {owned} / {total}',
  'Play! ({n} coins)': 'เล่นเลย! ({n} เหรียญ)',
  'No tickets and not enough coins yet. Win some battles and come back!': 'ยังไม่มีตั๋วและเหรียญยังไม่พอ ไปชนะการต่อสู้สักหน่อยแล้วกลับมานะ!',
  '×5 for {n} coins': '×5 ครั้ง {n} เหรียญ',
  'Five quick draws at once': 'เปิด 5 ครั้งรวดเดียว',
  'That is enough draws for today. Come back tomorrow!': 'วันนี้เปิดครบแล้ว พรุ่งนี้มาใหม่นะ!',
  'New drawing stamp! Find it in the stamp strip when you draw.': 'ได้ตัวปั๊มรูปใหม่! ไปหาได้ที่แถบตัวปั๊มตอนวาดรูป',
  'You already have everything of this tier, so here are coins instead.': 'ของระดับนี้มีครบหมดแล้ว รับเหรียญแทนนะ',
  'Guaranteed prize! Your lucky streak paid off.': 'รางวัลการันตี! เปิดมานานจนโชคเข้าข้างแล้ว',
  'No tickets and not enough coins left for now. Win some battles and come back!': 'ตอนนี้ตั๋วหมดและเหรียญไม่พอแล้ว ไปชนะการต่อสู้สักหน่อยแล้วกลับมานะ!',
  'Pick a colour! (this draw costs {n} coins)': 'เลือกสีเลย! (ครั้งนี้ใช้ {n} เหรียญ)',
  'Play again ({n} tickets left)': 'เล่นอีก (เหลือตั๋ว {n} ใบ)',
  'Play again ({n} coins)': 'เล่นอีก ({n} เหรียญ)',
  'Not enough coins (or draws left today) for five draws.': 'เหรียญ (หรือจำนวนครั้งของวันนี้) ไม่พอเปิด 5 ครั้ง',
  'Five fortunes!': 'ทายใจ 5 ครั้ง!',
  Common: 'ธรรมดา',
  Rare: 'หายาก',
  Epic: 'มหากาพย์',
  Legendary: 'ตำนาน',
  'An everyday ink or drawing stamp (hearts, flowers, cafe colours)': 'หมึกหรือตัวปั๊มรูปทั่วไป (หัวใจ ดอกไม้ สีคาเฟ่)',
  'A cute stamp, a bright ink or a fun victory stamp': 'ตัวปั๊มน่ารัก หมึกสีสด หรือตราประทับตอนชนะสนุก ๆ',
  'A ready-made weapon, a dress, a tiara, jewel inks or a special victory stamp': 'อาวุธสำเร็จรูป ชุดเดรส มงกุฎเจ้าหญิง หมึกสีอัญมณี หรือตราประทับพิเศษ',
  'The unicorn horn, the rainbow or a Paper Queen / King victory stamp': 'เขายูนิคอร์น สายรุ้ง หรือตราประทับ ราชินี / ราชาแห่งกระดาษ',

  // Hero names
  'Give your hero a name first!': 'ตั้งชื่อฮีโร่ก่อนนะ!',
  'Names can be up to 24 letters.': 'ชื่อยาวได้ไม่เกิน 24 ตัวอักษร',
  'That is the class name. Think of a name of your own!': 'นั่นคือชื่ออาชีพนะ คิดชื่อของตัวเองหน่อย!',
  'Your {cls} needs a name of its own. What is your hero called?': '{cls} ของคุณยังไม่มีชื่อของตัวเองเลย ฮีโร่ชื่ออะไรดี?',
  'A random name': 'สุ่มชื่อ',
  'Name your hero': 'ตั้งชื่อฮีโร่',
  'Save name': 'บันทึกชื่อ',
  'Nice to meet you, {name}!': 'ยินดีที่ได้รู้จัก {name}!',
  'Name (required)': 'ชื่อ (ต้องตั้ง)',

  // Hero slots
  'Your hero slots are full ({n}).': 'ช่องฮีโร่เต็มแล้ว ({n} ช่อง)',
  'Unlock hero slot {n}': 'ปลดล็อกช่องฮีโร่ที่ {n}',
  'Save up coins from battles and quests, or unlock it right away.': 'เก็บเหรียญจากการต่อสู้และภารกิจ หรือปลดล็อกทันทีก็ได้',
  Unlock: 'ปลดล็อก',
  'Not enough coins yet ({have} / {need})': 'เหรียญยังไม่พอ ({have} / {need})',
  'Hero slot {n} unlocked!': 'ปลดล็อกช่องฮีโร่ที่ {n} แล้ว!',
  'Unlock right away with real money': 'ปลดล็อกทันทีด้วยเงินจริง',
  'You have every hero slot. Erase a hero to make room for a new one.': 'มีช่องฮีโร่ครบทุกช่องแล้ว ลบฮีโร่ตัวเก่าก่อนถ้าอยากสร้างตัวใหม่',
  'Your hero slots are full. Unlock another one in Notebook → New Hero.': 'ช่องฮีโร่เต็มแล้ว ปลดล็อกช่องใหม่ได้ที่ สมุด → ฮีโร่ใหม่',

  // Creator: locked stamps
  '{name}: win it in the Paper Fortune Teller': '{name}: เปิดได้จากกระดาษทายใจ',
  'Locked stamp: {name}': 'ตัวปั๊มที่ยังไม่ได้: {name}',
  '{name} is a prize of the Paper Fortune Teller (Notebook → Gear), or comes in a Special Shelf set.': '{name} เป็นรางวัลจากกระดาษทายใจ (สมุด → อุปกรณ์) หรือได้จากชุดพิเศษในชั้นพิเศษ',

  // Special shelf
  'Themed Sets · ฿29': 'ชุดธีม · ฿29',
  'Each set gives you its drawing stamps and inks right away. You can also win them in the Paper Fortune Teller.': 'ซื้อชุดแล้วได้ตัวปั๊มและหมึกในชุดทันที ของในชุดยังเปิดได้จากกระดาษทายใจด้วย',
  'RGB Rainbow Pens': 'ปากกาสายรุ้ง RGB',
  'Two magic inks that change colour with every stroke: Rainbow and Pastel Rainbow. Only here.': 'หมึกวิเศษ 2 แท่ง เปลี่ยนสีทุกเส้นที่ลาก: สายรุ้ง และสายรุ้งพาสเทล มีขายที่นี่เท่านั้น',
  'Princess Set': 'ชุดเจ้าหญิง',
  'Tiara, party dress, star wand and heart stamps, Lilac ink, the Princess Win stamp and the set-only Princess Pink pen.':
    'ตัวปั๊มมงกุฎ ชุดเดรส ไม้กายสิทธิ์ดาว และหัวใจ หมึกสีม่วงไลแลค ตราประทับเจ้าหญิงผู้ชนะ และปากกาชมพูเจ้าหญิงที่มีเฉพาะในชุดนี้',
  'Knight Set': 'ชุดอัศวิน',
  'Sword, shield, battle axe, bow and hammer stamps, Ruby ink and the set-only Steel pen.': 'ตัวปั๊มดาบ โล่ ขวาน ธนู และค้อน หมึกสีทับทิม และปากกาสีเหล็กที่มีเฉพาะในชุดนี้',
  'Cute Pets Set': 'ชุดน้องเหมียวน้องกระต่าย',
  'Cat ears, bunny ears, ribbon bow and heart glasses stamps, Bubblegum and Peach inks and the So Cute stamp.': 'ตัวปั๊มหูแมว หูกระต่าย โบว์ และแว่นหัวใจ หมึกสีบับเบิ้ลกัมและพีช และตราประทับน่ารักที่สุด',
  'Sweet Cafe Set': 'ชุดคาเฟ่ขนมหวาน',
  'Bubble tea, cupcake, strawberry and donut stamps, and Milk Tea, Caramel and Sakura inks.': 'ตัวปั๊มชานมไข่มุก คัพเค้ก สตรอว์เบอร์รี และโดนัท หมึกสีชานม คาราเมล และซากุระ',
  'Magical Girl Set': 'ชุดสาวน้อยเวทมนตร์',
  'Magic staff, potion, moon, butterfly and unicorn horn stamps, Amethyst ink and the Unicorn Win stamp.': 'ตัวปั๊มคทาเวทมนตร์ ขวดยาวิเศษ พระจันทร์ ผีเสื้อ และเขายูนิคอร์น หมึกสีอเมทิสต์ และตราประทับยูนิคอร์นผู้ชนะ',
  'Fashionista Set': 'ชุดแฟชั่นนิสต้า',
  'Pleated skirt, high heel, handbag, lipstick and round glasses stamps, Rose Gold ink and the Superstar stamp.': 'ตัวปั๊มกระโปรงพลีท รองเท้าส้นสูง กระเป๋าถือ ลิปสติก และแว่นกลม หมึกสีโรสโกลด์ และตราประทับซูเปอร์สตาร์',
  'Hero Slot 3': 'ช่องฮีโร่ที่ 3',
  'Room for a third hero, right away.': 'เพิ่มที่ให้ฮีโร่ตัวที่ 3 ได้ทันที',
  'Hero Slot 4': 'ช่องฮีโร่ที่ 4',
  'Room for a fourth hero, right away.': 'เพิ่มที่ให้ฮีโร่ตัวที่ 4 ได้ทันที',
  'Hero Slot 5': 'ช่องฮีโร่ที่ 5',
  'Room for a fifth hero, right away.': 'เพิ่มที่ให้ฮีโร่ตัวที่ 5 ได้ทันที',
  'Hero Slot 6': 'ช่องฮีโร่ที่ 6',
  'Room for a sixth hero, right away.': 'เพิ่มที่ให้ฮีโร่ตัวที่ 6 ได้ทันที',

  // Inks
  'Peach Gel Pen': 'ปากกาเจลสีพีช',
  'Soft peach, like a summer fruit.': 'สีพีชนุ่ม ๆ เหมือนผลไม้หน้าร้อน',
  'Sakura Gel Pen': 'ปากกาเจลสีซากุระ',
  'Cherry-blossom pink for petals and cheeks.': 'สีชมพูซากุระ ไว้วาดกลีบดอกไม้และแก้มแดง ๆ',
  'Matcha Gel Pen': 'ปากกาเจลสีมัทฉะ',
  'Green-tea green, calm and tasty.': 'สีเขียวชาเขียว ดูสบายตาและน่ากิน',
  'Milk Tea Gel Pen': 'ปากกาเจลสีชานม',
  'Creamy milk-tea brown.': 'สีน้ำตาลชานมนุ่ม ๆ',
  'Caramel Gel Pen': 'ปากกาเจลสีคาราเมล',
  'Golden caramel for cookies and fur.': 'สีคาราเมลทอง ไว้วาดคุกกี้และขนสัตว์',
  'Cocoa Gel Pen': 'ปากกาเจลสีโกโก้',
  'Dark chocolate brown.': 'สีน้ำตาลช็อกโกแลตเข้ม',
  'Ocean Gel Pen': 'ปากกาเจลสีมหาสมุทร',
  'Deep sea blue for waves and whales.': 'สีฟ้าทะเลลึก ไว้วาดคลื่นและปลาวาฬ',
  'Tomato Gel Pen': 'ปากกาเจลสีมะเขือเทศ',
  'Juicy tomato red.': 'สีแดงมะเขือเทศฉ่ำ ๆ',
  'Lilac Gel Pen': 'ปากกาเจลสีไลแลค',
  'Dreamy lilac for fairy wings.': 'สีม่วงไลแลคชวนฝัน ไว้วาดปีกนางฟ้า',
  'Bubblegum Gel Pen': 'ปากกาเจลสีบับเบิ้ลกัม',
  'Sweet bubblegum pink. Pop!': 'สีชมพูหมากฝรั่งหวาน ๆ ป๊อป!',
  'Turquoise Gel Pen': 'ปากกาเจลสีเทอร์ควอยซ์',
  'Bright turquoise like a tropical lagoon.': 'สีฟ้าอมเขียวสดใสเหมือนทะเลสาบในเกาะเขตร้อน',
  'Sunflower Gel Pen': 'ปากกาเจลสีทานตะวัน',
  'Happy sunflower yellow.': 'สีเหลืองทานตะวันสดใส',
  'Plum Gel Pen': 'ปากกาเจลสีพลัม',
  'Rich plum purple.': 'สีม่วงลูกพลัมเข้ม ๆ',
  'Rose Gold Gel Pen': 'ปากกาเจลสีโรสโกลด์',
  'Fancy rose gold for jewellery.': 'สีโรสโกลด์หรูหรา ไว้วาดเครื่องประดับ',
  'Ruby Ink': 'หมึกสีทับทิม',
  'Deep jewel red.': 'สีแดงอัญมณีเข้ม',
  'Emerald Ink': 'หมึกสีมรกต',
  'Deep jewel green.': 'สีเขียวอัญมณีเข้ม',
  'Sapphire Ink': 'หมึกสีไพลิน',
  'Deep jewel blue.': 'สีน้ำเงินอัญมณีเข้ม',
  'Amethyst Ink': 'หมึกสีอเมทิสต์',
  'Deep jewel purple.': 'สีม่วงอัญมณีเข้ม',
  'Rainbow RGB Pen': 'ปากกาสายรุ้ง RGB',
  'Every stroke is the next colour of the rainbow.': 'ลากเส้นไหน เป็นสีถัดไปของสายรุ้ง',
  'Pastel Rainbow Pen': 'ปากกาสายรุ้งพาสเทล',
  'Every stroke is the next soft pastel colour.': 'ลากเส้นไหน เป็นสีพาสเทลนุ่ม ๆ สีถัดไป',
  'Princess Pink Pen': 'ปากกาชมพูเจ้าหญิง',
  'Only in the Princess set.': 'มีเฉพาะในชุดเจ้าหญิง',
  'Steel Pen': 'ปากกาสีเหล็ก',
  'Only in the Knight set: shiny steel for armour.': 'มีเฉพาะในชุดอัศวิน สีเหล็กเงาวับไว้วาดชุดเกราะ',

  // Drawing stamps (cosmetics)
  'Heart Stamp': 'ตัวปั๊มหัวใจ',
  'A big heart for your drawings.': 'หัวใจดวงโตสำหรับรูปวาด',
  'Flower Stamp': 'ตัวปั๊มดอกไม้',
  'A four-petal flower.': 'ดอกไม้สี่กลีบ',
  'Ribbon Bow Stamp': 'ตัวปั๊มโบว์',
  'A cute bow for hair, gifts and tails.': 'โบว์น่ารัก ติดผม ติดของขวัญ หรือติดหางก็ได้',
  'Strawberry Stamp': 'ตัวปั๊มสตรอว์เบอร์รี',
  'A juicy strawberry.': 'สตรอว์เบอร์รีลูกฉ่ำ',
  'Moon Stamp': 'ตัวปั๊มพระจันทร์',
  'A crescent moon for night monsters.': 'พระจันทร์เสี้ยวสำหรับมอนสเตอร์กลางคืน',
  'Music Note Stamp': 'ตัวปั๊มตัวโน้ต',
  'La la la!': 'ลา ลา ลา!',
  'Cat Ears Stamp': 'ตัวปั๊มหูแมว',
  'Turn anyone into a kitty. Nya!': 'เปลี่ยนใครก็ได้ให้เป็นน้องแมว เมี้ยว!',
  'Bunny Ears Stamp': 'ตัวปั๊มหูกระต่าย',
  'Long, floppy bunny ears.': 'หูกระต่ายยาว ๆ ห้อย ๆ',
  'Heart Glasses Stamp': 'ตัวปั๊มแว่นหัวใจ',
  'Heart-shaped sunglasses. So cool.': 'แว่นกันแดดรูปหัวใจ เท่สุด ๆ',
  'Round Glasses Stamp': 'ตัวปั๊มแว่นกลม',
  'Smart round glasses.': 'แว่นกลมดูฉลาด',
  'Cupcake Stamp': 'ตัวปั๊มคัพเค้ก',
  'A frosted cupcake with a cherry.': 'คัพเค้กแต่งครีม มีเชอร์รีด้านบน',
  'Bubble Tea Stamp': 'ตัวปั๊มชานมไข่มุก',
  'Bubble milk tea with pearls.': 'ชานมไข่มุกแก้วโต',
  'Donut Stamp': 'ตัวปั๊มโดนัท',
  'A round donut. Do not eat the paper!': 'โดนัทกลม ๆ ห้ามกินกระดาษนะ!',
  'Lipstick Stamp': 'ตัวปั๊มลิปสติก',
  'A lipstick for glamorous monsters.': 'ลิปสติกสำหรับมอนสเตอร์สายแฟชั่น',
  'Handbag Stamp': 'ตัวปั๊มกระเป๋าถือ',
  'A fancy handbag.': 'กระเป๋าถือสุดหรู',
  'Dagger Stamp': 'ตัวปั๊มกริช',
  'A small, quick blade.': 'มีดสั้นคล่องมือ',
  'Shield Stamp': 'ตัวปั๊มโล่',
  'A knight shield with a cross.': 'โล่อัศวินลายกากบาท',
  'Potion Stamp': 'ตัวปั๊มขวดยาวิเศษ',
  'A bubbling magic potion.': 'ยาวิเศษเดือดปุด ๆ',
  'Sword Stamp': 'ตัวปั๊มดาบ',
  'A ready-made hero sword. Draw a hand to hold it!': 'ดาบฮีโร่สำเร็จรูป วาดมือมาจับเลย!',
  'Battle Axe Stamp': 'ตัวปั๊มขวานศึก',
  'A heavy battle axe.': 'ขวานศึกเล่มหนัก',
  'Bow and Arrow Stamp': 'ตัวปั๊มธนู',
  'A bow with an arrow ready.': 'คันธนูพร้อมลูกศร',
  'Hammer Stamp': 'ตัวปั๊มค้อน',
  'A giant hammer. Bonk!': 'ค้อนยักษ์ โป๊ก!',
  'Spear Stamp': 'ตัวปั๊มหอก',
  'A long, pointy spear.': 'หอกยาวปลายแหลม',
  'Magic Staff Stamp': 'ตัวปั๊มคทาเวทมนตร์',
  'A wizard staff with a glowing orb.': 'คทาพ่อมดมีลูกแก้วเรืองแสง',
  'Party Dress Stamp': 'ตัวปั๊มชุดเดรส',
  'A twirly party dress.': 'ชุดเดรสปาร์ตี้หมุนแล้วพลิ้ว',
  'Pleated Skirt Stamp': 'ตัวปั๊มกระโปรงพลีท',
  'A pleated school skirt.': 'กระโปรงพลีทแบบนักเรียน',
  'High Heel Stamp': 'ตัวปั๊มรองเท้าส้นสูง',
  'A sparkly high-heeled shoe.': 'รองเท้าส้นสูงวิบวับ',
  'Tiara Stamp': 'ตัวปั๊มมงกุฎเจ้าหญิง',
  'A princess tiara with a gem.': 'มงกุฎเจ้าหญิงประดับอัญมณี',
  'Butterfly Stamp': 'ตัวปั๊มผีเสื้อ',
  'Butterfly wings for fairies.': 'ปีกผีเสื้อสำหรับนางฟ้า',
  'Star Wand Stamp': 'ตัวปั๊มไม้กายสิทธิ์ดาว',
  'A magic wand with a star.': 'ไม้กายสิทธิ์ปลายรูปดาว',
  'Unicorn Horn Stamp': 'ตัวปั๊มเขายูนิคอร์น',
  'A magical swirly unicorn horn.': 'เขายูนิคอร์นเกลียววิเศษ',
  'Rainbow Stamp': 'ตัวปั๊มสายรุ้ง',
  'A rainbow arch. Try it with the rainbow pen!': 'สายรุ้งโค้ง ลองใช้กับปากกาสายรุ้งดูสิ!',

  // Victory stamps
  'Cutest Stamp': 'ตราประทับน่ารักที่สุด',
  'Pink ink: the cutest win ever.': 'หมึกสีชมพู ชัยชนะที่น่ารักที่สุด',
  'So Cool Stamp': 'ตราประทับเท่สุด ๆ',
  'Icy blue ink for cool wins.': 'หมึกสีฟ้าเย็น ๆ สำหรับชัยชนะสุดเท่',
  'Best Friends Stamp': 'ตราประทับเพื่อนรัก',
  'For wins with your best friend.': 'สำหรับชัยชนะคู่กับเพื่อนสนิท',
  'Class Hero Stamp': 'ตราประทับฮีโร่ประจำห้อง',
  'The hero of the whole class.': 'ฮีโร่ของทั้งห้อง',
  'Superstar Stamp': 'ตราประทับซูเปอร์สตาร์',
  'A sparkly superstar win.': 'ชัยชนะระดับซูเปอร์สตาร์วิบวับ',
  'Princess Win Stamp': 'ตราประทับเจ้าหญิงผู้ชนะ',
  'A royal pink win.': 'ชัยชนะสีชมพูแบบราชวงศ์',
  'Paper Queen Stamp': 'ตราประทับราชินีแห่งกระดาษ',
  'The rarest crown in the notebook.': 'มงกุฎที่หายากที่สุดในสมุด',
  'Paper King Stamp': 'ตราประทับราชาแห่งกระดาษ',
  'Unicorn Win Stamp': 'ตราประทับยูนิคอร์นผู้ชนะ',
  'A magical rainbow win.': 'ชัยชนะสายรุ้งวิเศษ',

  // Words pressed by the victory stamps
  '♡ SO CUTE ♡': '♡ น่ารักที่สุด ♡',
  'SO COOL!': 'เท่สุด ๆ!',
  'BFF ♡': 'เพื่อนรัก ♡',
  'CLASS HERO': 'ฮีโร่ประจำห้อง',
  '☆ SUPERSTAR ☆': '☆ ซูเปอร์สตาร์ ☆',
  '♛ PRINCESS ♛': '♛ เจ้าหญิง ♛',
  '♛ PAPER QUEEN ♛': '♛ ราชินีกระดาษ ♛',
  '♚ PAPER KING ♚': '♚ ราชากระดาษ ♚',
  '🦄 UNICORN WIN': '🦄 ยูนิคอร์นชนะ',

  // Stamp labels in the creator
  Heart: 'หัวใจ',
  Flower: 'ดอกไม้',
  'Ribbon bow': 'โบว์',
  Strawberry: 'สตรอว์เบอร์รี',
  Moon: 'พระจันทร์',
  'Music note': 'ตัวโน้ต',
  'Cat ears': 'หูแมว',
  'Bunny ears': 'หูกระต่าย',
  'Heart glasses': 'แว่นหัวใจ',
  'Round glasses': 'แว่นกลม',
  Cupcake: 'คัพเค้ก',
  'Bubble tea': 'ชานมไข่มุก',
  Donut: 'โดนัท',
  Lipstick: 'ลิปสติก',
  Handbag: 'กระเป๋าถือ',
  Dagger: 'กริช',
  Shield: 'โล่',
  Potion: 'ยาวิเศษ',
  Sword: 'ดาบ',
  'Battle axe': 'ขวานศึก',
  'Bow and arrow': 'ธนู',
  Hammer: 'ค้อน',
  Spear: 'หอก',
  'Magic staff': 'คทาเวทมนตร์',
  'Party dress': 'ชุดเดรส',
  'Pleated skirt': 'กระโปรงพลีท',
  'High heel': 'รองเท้าส้นสูง',
  Tiara: 'มงกุฎเจ้าหญิง',
  Butterfly: 'ผีเสื้อ',
  'Star wand': 'ไม้กายสิทธิ์ดาว',
  'Unicorn horn': 'เขายูนิคอร์น',
  Rainbow: 'สายรุ้ง',

  // Funny fortunes
  'Today your eraser will run away. It will be found in your friend’s pencil case.': 'วันนี้ยางลบของเธอจะหนีออกจากบ้าน แล้วไปโผล่ในกล่องดินสอของเพื่อน',
  'The teacher will call your name right after a giant yawn.': 'ครูจะเรียกชื่อเธอตอนที่เธอเพิ่งหาวกว้างที่สุดในชีวิต',
  'Your lunch will be delicious. Your friend will want half.': 'ข้าวกลางวันวันนี้อร่อยมาก แต่เพื่อนจะขอแบ่งครึ่งหนึ่ง',
  'A cat will look at you as if you owe it money.': 'จะมีแมวมองเธอเหมือนเธอติดเงินมันอยู่',
  'You will laugh so hard that milk comes out of your nose. Careful!': 'เธอจะหัวเราะหนักจนนมพุ่งออกจมูก ระวังด้วย!',
  'Your pencil will break at the most exciting part of your drawing.': 'ไส้ดินสอจะหักตรงช่วงที่วาดสนุกที่สุดพอดี',
  'Today is a great day to draw a monster with seven noses.': 'วันนี้เหมาะมากกับการวาดมอนสเตอร์ที่มีเจ็ดจมูก',
  'You will find a coin on the floor. It is chocolate. Even better!': 'เธอจะเจอเหรียญตกที่พื้น เป็นช็อกโกแลต ดีกว่าเดิมอีก!',
  'Your hair will be perfect today. The wind disagrees.': 'ผมของเธอวันนี้จะสวยเป๊ะ แต่ลมไม่เห็นด้วย',
  'A pigeon admires you from afar.': 'มีนกพิราบตัวหนึ่งแอบชื่นชมเธออยู่ห่าง ๆ',
  'Rock, paper or scissors? Your gut says paper. Your gut is hungry.': 'ค้อน กระดาษ หรือกรรไกร? ใจบอกว่ากระดาษ แต่ท้องบอกว่าหิว',
  'You will sneeze at exactly the wrong moment.': 'เธอจะจามในจังหวะที่ไม่ควรจามที่สุด',
  'Your crush will say hi. To the person behind you.': 'คนที่แอบชอบจะโบกมือทักทาย... ให้คนที่ยืนข้างหลังเธอ',
  'Your next monster will be so scary that you get scared too.': 'มอนสเตอร์ตัวต่อไปที่เธอวาดจะน่ากลัวจนเธอกลัวเอง',
  'A secret admirer has hidden a snack for you. Check your bag! (Maybe.)': 'มีคนแอบชอบซ่อนขนมไว้ให้ เช็กกระเป๋าดูสิ! (มั้งนะ)',
  'Your shoelace will come undone during the most important walk of the day.': 'เชือกรองเท้าจะหลุดตอนที่เธอกำลังเดินอย่างเท่ที่สุดของวัน',
  'You are 87% more stylish than yesterday.': 'วันนี้เธอดูดีกว่าเมื่อวาน 87%',
  'Today you will win. Maybe a battle, maybe an argument with your little brother.': 'วันนี้เธอจะชนะ อาจเป็นการต่อสู้ หรืออาจเป็นการเถียงกับน้อง',
  'Beware of the class clown. Also, be the class clown.': 'ระวังตัวตลกประจำห้องไว้ หรือไม่ก็เป็นตัวตลกประจำห้องซะเลย',
  'You will remember the answer three seconds after the test ends.': 'เธอจะนึกคำตอบออก 3 วินาทีหลังสอบเสร็จ',
  'A ghost wants to be your friend. Say yes, ghosts are cool.': 'มีผีอยากเป็นเพื่อนเธอ ตอบตกลงไปเถอะ ผีเท่จะตาย',
  'You will draw a perfect circle by accident and nobody will believe you.': 'เธอจะวาดวงกลมได้กลมเป๊ะโดยบังเอิญ แต่ไม่มีใครเชื่อ',
  'The fridge has something tasty. Go look!': 'ในตู้เย็นมีของอร่อยรออยู่ ไปดูเร็ว!',
  'Your best friend thinks your drawings are amazing. They are right.': 'เพื่อนสนิทคิดว่ารูปที่เธอวาดสุดยอดมาก และเขาคิดถูก',
  'You will dance like nobody is watching. Somebody is watching.': 'เธอจะเต้นเหมือนไม่มีใครดู แต่มีคนดูอยู่นะ',
  'Your future holds a lot of glitter. Like, a LOT.': 'อนาคตของเธอเต็มไปด้วยกากเพชร เยอะมาก มากจริง ๆ',
  'Dragons will be jealous of your hairstyle.': 'มังกรจะอิจฉาทรงผมของเธอ',
  'You will become a Paper Legend. First, finish your homework.': 'เธอจะได้เป็นตำนานแห่งกระดาษ แต่ทำการบ้านให้เสร็จก่อนนะ',
};
